/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Tour_Datasets_BodyInputs */



/**
* | output |
* | --- |
* | "Structured data the AI can query and analyze for you." |
*
* @param {Onboarding_Tour_Datasets_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_tour_datasets_body = /** @type {((inputs?: Onboarding_Tour_Datasets_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Tour_Datasets_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Strukturierte Daten, die die KI für dich abfragen und auswerten kann.")
	return /** @type {LocalizedString} */ ("Structured data the AI can query and analyze for you.")
});